import { render, staticRenderFns } from "./OutboundInvestment.vue?vue&type=template&id=533ed9c2&scoped=true&"
import script from "./OutboundInvestment.vue?vue&type=script&lang=js&"
export * from "./OutboundInvestment.vue?vue&type=script&lang=js&"
import style0 from "./OutboundInvestment.vue?vue&type=style&index=0&id=533ed9c2&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533ed9c2",
  null
  
)

export default component.exports